export const  USERINFO = "userInfo";
export const TOKEN = "token";



// WEBPACK FOOTER //
// ./src/utils/constants.js